import { colors, Button } from '@insurancemenu/imenu-components-lib';
import {
  ArrowLong,
  CheckboxOutlineBlank,
  Checkbox as CheckboxIcon,
  Edit,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import { createStyles } from './styles';

interface BatchGuidelinesProps {
  onClose: () => void;
  onAction?: () => void;
}

const BatchGuidelines = ({ onClose, onAction }: BatchGuidelinesProps): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.warningContent}>
      <p className={classes.warningText}>Select employees using check boxes to use batch feature</p>
      <div className={classes.demoButtons}>
        <CheckboxOutlineBlank width="3.2rem" color={colors.blue[600]} />
        <span className={classes.arrow}>
          <ArrowLong width="6rem" />
        </span>
        <CheckboxIcon width="3.2rem" color={colors.blue[600]} />
      </div>
      <div className={classes.buttonsWrapper}>
        <Button color="primary" type="outlined" className={classes.cancelWarningModalBtn} onClick={onClose}>
          Close
        </Button>
        {onAction && (
          <Button
            size="small"
            color="primary"
            leftIconProp={<Edit />}
            className={classes.actionButton}
            onClick={onAction}
          >
            Edit Classes
          </Button>
        )}
      </div>
    </div>
  );
};

export default BatchGuidelines;
